// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__VgkM+","editingContainer":"Tag_editingContainer__-Lh1m","count":"Tag_count__AnxVo","cog":"Tag_cog__SsuBj"};